<template>
  <div class="pub-redirect">
    <div v-if="error" class="pub-redirect-error">
      <p>{{ error }}</p>
      <button @click="$router.push('/home')">Go to feed</button>
    </div>
    <div v-else class="pub-redirect-loading">
      <div class="spinner" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfRedirect',

  async mounted () {
    const id = this.$route.params.id
    try {
      // Fetch the publication data
      const { data } = await this.$axios.post("/conference.php", {type:"getConference", conferenceId:id});
      if (!data) {
        this.error = 'Conference not found'
        return
      } 
      if(data.end) {
        this.error = 'Conference ended'
        return
      }
      // pub.likes = []
      // pub.views = []
      // Store the id so Publications.vue knows to jump to it after loading the feed
      this.$store.commit('setCurrentConference', data)

      // Redirect to home — Home.vue is already mounted (v-show), Publications will handle the rest
      this.$router.replace('/home')
    } catch (e) {
      console.error(e)
      this.error = "Error loading conference"
    }
  },

  data () {
    return { error: '' }
  },
}
</script>

<style scoped>
.pub-redirect {
  position: fixed;
  inset: 0;
  background: #0a0e26;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 212, 255, 0.2);
  border-top-color: #00d4ff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
.pub-redirect-error {
  text-align: center;
  color: #e0f7ff;
}
.pub-redirect-error button {
  margin-top: 16px;
  padding: 10px 24px;
  background: rgba(0, 212, 255, 0.15);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 8px;
  color: #00d4ff;
  cursor: pointer;
  font-size: 14px;
}
</style>